import { TabsDesignTokens } from '@primeuix/themes/types/tabs';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/tabs/index.ts
const tabs = tDeep(componentCommon.tabs);

export const TabsTelekomDT: TabsDesignTokens = {
  tablist: {
    background: tabs.tablist.background,
  },
  tab: {
    color: tabs.tab.color,
    hoverColor: tabs.tab.hover.color,
    activeColor: tabs.tab.active.color,
    activeBorderColor: tabs.tab.active.border.color,
    borderWidth: `0 0 ${tabs.tab.border.width} 0`,
    padding: `${tabs.tab.padding.y} ${tabs.tab.padding.x}`,
  },
  tabpanel: {
    background: tabs.tabpanel.background,
    padding: `${tabs.tabpanel.padding.top} ${tabs.tabpanel.padding.right} ${tabs.tabpanel.padding.bottom} ${tabs.tabpanel.padding.left}`,
  },
  navButton: {
    background: tabs.nav.button.background,
  },
  activeBar: {
    background: tabs.active.bar.background,
  },
};
